import Vue from "vue";
import { HapiService } from "@/core/services/hapi.service";

export default {
  data() {
    return {
      user_info_settings: [],
      user_info_payment_settings: [],
      user_wallet: null
    };
  },
  mounted() {
    // Init Quick User Panel
    this.fetchUserInfoSettings();
    this.fetchUserWallet();
  },
  computed: {
    userInfo() {
      const cookieClientId = window.KTCookie.getCookie(
        "_HAPI_OVERRIDE_CLIENT_ID"
      );
      return {
        customerId: cookieClientId || Vue.prototype.$auth.user.sub
      };
    }
  },
  methods: {
    normalizeWalletResponse(wallet) {
      const newWallet = {
        ...wallet
      };
      if (typeof newWallet.balance.USD != "undefined") {
        newWallet.balance = {
          amount: (newWallet.balance.USD / 100).toFixed(2), // "100.00"
          currency: "USD"
        };
      }
      return newWallet;
    },
    async fetchUserInfoSettings() {
      try {
        const response = await HapiService.getATSUserSetting();
        this.user_info_settings = this.mapObjectToKeyValueList(
          response.data.settings || {}
        );
        this.user_info_payment_settings = (
          response.data.payment_settings || []
        ).map(item => {
          return {
            currency: item.currency,
            settings: this.mapObjectToKeyValueList(item)
          };
        });
      } catch (error) {
        // eslint-disable-next-line no-console
      }
    },
    async fetchUserWallet() {
      try {
        const response = await HapiService.getWallet();
        this.user_wallet = this.normalizeWalletResponse(response.data);
      } catch (error) {
        console.error(error);
      }
    },
    mapObjectToKeyValueList(object) {
      const keyValueList = [];
      for (let i = 0; i < Object.keys(object).length; i++) {
        const key = Object.keys(object)[i];
        keyValueList.push({
          key: this.capitalizeLetters(key),
          value: this.capitalizeValue(object[key])
        });
      }
      return keyValueList;
    },
    updateCustomerId() {
      // use js to ask for a new value
      const newValue = prompt(
        "Please enter new customer id",
        this.userInfo.customerId
      );
      if (newValue) {
        // update cookie
        window.KTCookie.setCookie("_HAPI_OVERRIDE_CLIENT_ID", newValue, 365);
        // reload page
        window.location.reload();
      }
    }
  }
};
